import {
  isTourPointsType,
  Tour,
  TourPoints,
  TourPointsConfig,
} from "model/Tour/Tour";
import { nonUndefined } from "Utility";
import { mapStages } from "./FsStage";
import { FsTour, FsTourPoints, FsTourPointsConfig } from "db/model/tour/FsTour";
import { mapMultiple } from "../Utility";

export const mapTour = (fsModel: FsTour, id: string): Tour | undefined => {
  if (
    !fsModel.name ||
    !fsModel.trigram ||
    !fsModel.startTimeMs ||
    !fsModel.endTimeMs
  ) {
    return undefined;
  }

  const points = mapTourPoints(fsModel.points);
  if (!points) {
    return undefined;
  }

  return {
    id,
    description: fsModel.description,
    endTimeMs: fsModel.endTimeMs,
    filterName: fsModel.filterName,
    groupTournaments: fsModel.groupTournaments,
    imageIdOverride: fsModel.imageIdOverride,
    links: fsModel.links,
    name: fsModel.name,
    points,
    shortName: fsModel.shortName ?? fsModel.name,
    stages: mapStages(nonUndefined(fsModel.stages ?? [])),
    startTimeMs: fsModel.startTimeMs,
    theme: fsModel.theme,
    trigram: fsModel.trigram,
  };
};

const mapTourPoints = (
  fsModel: FsTourPoints | undefined
): TourPoints | undefined => {
  if (!fsModel || !isTourPointsType(fsModel.type)) {
    return undefined;
  }

  return {
    config: !!fsModel.config
      ? mapMultiple(fsModel.config, mapTourPointsConfig)
      : [],
    ignoreTournamentIds: fsModel.ignoreTournamentIds,
    overrides: fsModel.overrides,
    type: fsModel.type,
  };
};

const mapTourPointsConfig = (fsModel: FsTourPointsConfig): TourPointsConfig => {
  return {
    distribution: fsModel.distribution ?? [],
    tournamentIds: fsModel.tournamentIds ?? [],
  };
};
